var framework = {
	next: "",
	folder: "",
	urlArry: [],
	isFirst: true,
	scrollTop: 0,
	isBack: false,
	init: function(){
		framework.checkURL();
		framework.nav();
		window.addEventListener('popstate', function(e) {
			e.preventDefault();
			framework.isBack = true;
			framework.next = location.pathname;
			framework.changeURL();
		});
	},
	nav: function(){
		$(`a[target!="_blank"]`).off().on("click", function(e){
			let $this = $(this);
			if( $this.hasClass("ga") ){
				let action 		= $this.attr("data-action");
				let category 	= $this.attr("data-category");
				let label 		= $this.attr("data-label");
				common.sendGa(category, action, label);
			}
			if( $this.hasClass("scrolllink") ){
				e.preventDefault();
				common.scrollToPosition($this)
			}else if( $this.hasClass("position_link") ){
				e.preventDefault();
				common.scrollToPosByNum(0);
			}else if( $this.hasClass("nav_ui") ){
				
			}else if( $this.hasClass("external") ){
				
			}else{
				e.preventDefault();
				if(isSP || common.isIPad || $html.classList.contains("iPad")){
					framework.scrollTop = $(document).scrollTop();
				}else{
					framework.scrollTop = scrollbar.scrollTop;
				}
				framework.isBack = false;
				//console.log(framework.scrollTop);
				framework.next = $(this).attr("href");
				framework.changeURL();
			}
		});
		$("a#btn_menu").off().on("click", function(){
			if( !$html.classList.contains("menu") ){
				$html.classList.add("menu");
			}else{
				$html.classList.remove("menu");
			}
		});
		$("a#btn_help").off().on("click", function(){
			if( !$html.classList.contains("show_float_block") ){
				$html.classList.add("show_float_block");
			}else{
				$html.classList.remove("show_float_block");
			}
		});
		$("a#btn_close_float").off().on("click", function(){
			$html.classList.remove("show_float_block");
		});
		//console.log("page nav");
		$("#submit_register").off().on("click", function(){
			let category 	= "account";
			let action 		= "register";
			let label 		= "register";
			common.sendGa(category, action, label);
		});
		
		shareSNS.nav();
		$("a.btn_viewmore").off().on("click", function(e){
			e.preventDefault();
			let lang = $(this).attr("data-lang");
			let $block = "";
			if(lang === "jp"){
				$block = $(".content_extend_jp");
			}else if(lang === "en"){
				$block = $(".content_extend_en");
			}else{
				//両方
				$block = $(".content_extend_jp, .content_extend_en");
			}
			//console.log($block);
			$(this).remove();
			$block.find(".inner").animate({
				height: "toggle", opacity: "toggle"
			}, 400);
		});
	},
	loadPage: function(){
		if( $html.classList.contains("menu") ){
			$html.classList.remove("menu");
		}
		$.get(framework.next, {},function(data){
			let loadedContent 	= $(data),
				ttl 			= loadedContent.filter("title")[0].innerHTML,//ページタイトル
				$content 		= $("[data-page] #page_content"),//書き換えるDOM
				content 		= $("#page_loadcontent", loadedContent)[0];//ロードしたコンテンツの中身
			$content.html(content);//ロードしたコンテンツをappend
			document.title = ttl;//ページタイトルを書き換え
			
			setTimeout(function(){
				framework.afterChangePage();
			}, 100);
		});
	},
	afterChangePage: function(){
		//console.log("after change page");
		//console.log("page:", framework.folder);
		if(scrollbar){
			scrollbar.destroy();
		}
		if(isSP || common.isIPad || $html.classList.contains("iPad") ){
				
		}else{
			scrollbar = Scrollbar.init( document.querySelector('#page') );
		}
		window.scrollTo(0, 0);
		common.initScroll();
		framework.nav();
		common.resize();
		
		framework.reset();
		topSlideshow.clear();
		framework.checkScroll();
		if( framework.urlArry[2] === "" ){
			infiniteSlide.init();
			$("body").addClass("top");
		}else{
			$("body").removeClass("top");
			if( $("header#global_header").hasClass("active") ){
				$("header#global_header").addClass("active");
			}
		}
		
		if( framework.urlArry[2] === "idea"){
			if( !$html.classList.contains("page_idea") ){
				$html.classList.add("page_idea");
			}
		}else{
			if( $html.classList.contains("page_idea") ){
				$html.classList.remove("page_idea");
			}
		}
		
		setTimeout(function(){
			common.resize();
			$("body").removeClass("change");
			$("body").removeClass("close_idea");
			framework.checkScroll();
			if(framework.urlArry[2] === "projects"){
				if( $("#page_project").hasClass("detail") ){
					$("#page_project").addClass("active");
					projects.init();
				}
			}else if(framework.urlArry[2] === "faq"){
				faq.init();
			}else if(framework.urlArry[2] === "info"){
				if( $(".img_slideshow").length > 0 ){
					pSlide.init();
				}
			}else if( framework.urlArry[2] === "" ){
				common.checkScrollPostiion();
				framework.topAnimation();
			}
			if( framework.urlArry[2] === "idea" ){
				//少しdelayして表示
				framework.removeEmptyP();
				setTimeout(function(){
					$("#page_idea").removeClass("disable");
				}, 600);
			}else if( framework.urlArry[2] === "about" ){
				$(".main_inner").removeClass("disable");
			}else if( framework.urlArry[2] === "contact" ){
				contact.init();
			}
			if(scrollbar){
				scrollbar.update();
				if(framework.isBack){
					common.scrollTo(framework.scrollTop);
					setTimeout(function(){
						framework.checkScroll();
					}, 300);
				}
			}
		}, 200);
	},
	checkScroll: function(){
		let topD,btmD;
		if(isSP || common.isIPad || $html.classList.contains("iPad")){
			topD 		= $(document).scrollTop();
			common.topD = topD;
		}else{
			topD = scrollbar.scrollTop;
		}
		btmD = topD + window.innerHeight;
		common.topD = topD;
		//console.log("checkScroll: ",topD, btmD);
		common.scrl(topD, btmD);
	},
	topAnimation: function(){
		let isvisited = Cookies.get("visited");
		let needDebug = false; //デバッグするときはクッキーをオフ
		if(needDebug){
			startAnimation();
		}else{
			if(isvisited === "1"){
				$("body").addClass("noload");
				$("body").removeClass("loading");
				$("#kv").addClass("active");
				$("#kv").addClass("show");
				$("body").removeClass("disable");
				$("header#global_header").addClass("active");
				//console.log("訪問済み");
				topSlideshow.init();
			}else{
				Cookies.set('visited', '1', { expires: 1 })
				startAnimation();
			}
		}
		ideaSlide.init();
		function startAnimation(){
			$("body").removeClass("disable");
			let imgArry = [];
			$("img").each(function(){
				let src = $(this).attr("src");
				console.log( src );
				
				imgArry.push( src );
			});
			
			preload.startLoad(imgArry.length, imgArry).done(function(){
				setTimeout(function(){
					$("body").addClass("loaded");
					setTimeout(function(){
						$("#kv").addClass("active");
						setTimeout(function(){
							$("#kv").addClass("show");
							setTimeout(function(){
								$("body").removeClass("loading loaded");
								$("header#global_header").addClass("active");
								topSlideshow.init();
							}, 600);
						}, 2500);
					}, 1100);	
				}, 1000);
			});
		}
	},
	checkURL: function(){
		let url 	= location.href,
			prop 	= location.pathname,
			arry 	= prop.split("/");
		//console.log("checkURL: ", url, arry);
		if(arry[1] === ""){
			
		}
		framework.folder = arry[2];
		framework.urlArry = arry;
		//console.log(framework.urlArry[2])
		//console.log("checkURL folder:", framework.folder, arry, framework.urlArry);
		//ここでURLを取得して解析
		if( framework.isFirst ){ //ページの訪問時にはページ特有関数を呼ぶだけ
			framework.afterChangePage();
			framework.isFirst = false;
		}else{ //ページをロードする
			framework.loadPage();
		}
	},
	changeURL: function(){
		window.history.pushState(null, null, framework.next);
		let duration = 400;
		if( framework.urlArry[2] === "idea" ){
			$("body").addClass("close_idea");
			duration = 500;
		}else{
			$("body").addClass("change"); 
		}
		
		setTimeout(function(){
			if( framework.urlArry[2] === "idea" ){
				$("body").addClass("change"); 
			}
			framework.checkURL();
		}, duration);
	},
	reset: function(){
		infiniteSlide.reset();
	},
	removeEmptyP: function(){
		$(".content_extend_jp p").each(function(){
			let $this = $(this);
			let val = $(this).text();
			if(val === "" || val === " "){
				$this.remove();
			}
		});
		$(".content_extend_en p").each(function(){
			let $this = $(this);
			let val = $(this).text();
			if(val === "" || val === " "){
				$this.remove();
			}
		});
	}
}
let topSlideTimer;
let topSlideshow = {
	count: 0,
	max: 3,
	duration: 5000,
	init: function(){
		topSlideshow.max = $("#img_kv ul li").length;
		topSlideshow.count = 0;
		topSlideTimer = setInterval(function(){
			topSlideshow.count++;
			if(topSlideshow.count >= topSlideshow.max){
				topSlideshow.count = 0;
			}
			$("#img_kv ul li").removeClass();
			$("#img_kv ul li").eq(topSlideshow.count).addClass("active");
		}, topSlideshow.duration);
	},
	clear: function(){
		clearInterval(topSlideTimer);
	}
}